import { CSSProperties } from 'react';
import styled from 'styled-components';
import { spacing } from '../../style';

interface VerticalGroupProps {
  bottomItemMargin?: keyof typeof spacing;
  alignItems?: CSSProperties['alignItems'];
}

const VerticalGroup = styled.div<VerticalGroupProps>`
  display: flex;
  flex-direction: column;
  align-items: ${props => props.alignItems};

  > *:not(:only-child):not(:last-child) {
    margin-bottom: ${props => spacing[props.bottomItemMargin || 'xs']};
  }
`;

export default VerticalGroup;
